import { GraphQLClient } from "../../../../../shared/gql-client";
import * as gqlBuilder from "gql-query-builder";
import { gql } from "@apollo/client";
import { DealerRequestModel } from "../../domain/models/dealerModel";

export default class RequestService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  getRequestsFromDay(day: string): Promise<DealerRequestModel[]> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.query({
        operation: "planningDealerRequests",
        variables: {
          date: { type: "Date!", value: day },
        },
        fields: [
          {
            relation: ["id", "name"],
          },
          {
            deliver_requests: [
              "id",
              "type",
              {
                source: [
                  "__typename",
                  {
                    "... on Tire": ["id"],
                  },
                  {
                    "... on Tireset": [
                      "id",
                      "type",
                      {
                        car: ["id", "licence", "label"],
                      },
                    ],
                  },
                ],
              },
              {
                relation: ["id", "name"],
              },
            ],
          },
          "pickup_amount",
        ],
      });

      this.client
        ?.query("planningDealerRequests", gql(query), variables)
        .then((response) => {
          const data = response as DealerRequestModel[];
          if (data.length === 0) {
            resolve([]);
          }

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  removeRequestsFromRoute(requestIds: string[]): Promise<boolean | undefined> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "removeRequestsFromRoute",
        variables: {
          request_ids: { type: "[ID!]!", value: requestIds },
        },
      });

      this.client
        ?.mutate("removeRequestsFromRoute", gql(query), variables)
        .then((response) => {
          const data = response as boolean;

          if (!data) {
            resolve(undefined);
          }

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
